<template>
  <div
    :style="{ display: !isHideMenu ? 'unset' : 'none' }"
  >
    <div
      v-show="!isErrorPage"
      class="header-v2"
      :class="[openHambuger ? 'header-default' : 'header-opacity']"
    >
      <div class="logo">
        <img
          :src="imageIcon"
          class="repeat"
        >
        <div class="cover-content">
          <span class="text">{{ title }}</span>
          <button
            v-if="checkStore"
            class="button"
            @click="openModalCofirm"
          >
            変更
          </button>
        </div>
      </div>
      <img
        v-show="!openHambuger"
        src="@/assets/images/v2/Menu.png"
        class="menu"
        @click="openHambuger = true"
      >
      <img
        v-show="openHambuger"
        src="@/assets/images/v2/icon-menu-active.svg"
        class="menu"
        @click="openHambuger = false"
      >
      <Hambuger
        :open="openHambuger"
        @close="close"
      />
    </div>
    <ConfirmModal
      ref="confirmModal"
      :title="confirmCategory.title"
      :content="confirmCategory.content"
      :text-submit="confirmCategory.textSubmit"
      :text-cancel="confirmCategory.textCancel"
      @submit="redirectToHomePage"
    />
  </div>
</template>

<script>
import { ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Hambuger from './Hambuger.vue'
import ConfirmModal from '@/components/Modal/ConfirmModal.vue'
import { CONFIRM_CATEGORY } from '@/assets/js/common.js'

export default {
  // eslint-disable-next-line vue/no-reserved-component-names
  name: 'Header',
  components: {
    Hambuger,
    ConfirmModal
  },
  setup () {
    const openHambuger = ref(false)
    const checkStore = ref(false)
    const title = ref(null)
    const confirmCategory = ref({ ...CONFIRM_CATEGORY })
    const imageIcon = ref(require('@/assets/images/v2/icon-home-store.svg'))
    const isErrorPage = ref(true)
    const confirmModal = ref(null)
    const isHideMenu = ref(false)

    const route = useRoute();
    const router = useRouter();

    const isUserExists = () => {
      return sessionStorage.getItem('userExists') === 'true'
    }
    
    watch(
      route,
      (to) => {
        checkStore.value = false
        openHambuger.value = false
        getIcon(to.name)
        getTitle(to.name)
      }
    )

    watch(
      route,
      (to) => {
        isErrorPage.value = to.meta.isErrorPage
        isHideMenu.value = !isUserExists()
      }
    )

    const openModalCofirm = () => {
      confirmModal.value.show()
    }

    const redirectToHomePage = () => {
      router.push({ name: 'map_v2' })
    }

    const close = () => {
      openHambuger.value = false
    }

    const getIcon = (el) => {
      const arrayCartIcon = ['cart_v2', 'pay_v2', 'pay_complete_v2']
      const arrayHistoryIcon = ['order_history_v2', 'store_detail_two_v2', 'privacypolicy_v2']
      switch (el) {
        case arrayCartIcon.find((item) => item === el):
          imageIcon.value = require('@/assets/images/v2/icon-cart-header.svg')
          break
        case 'good_detail':
          imageIcon.value = require('@/assets/images/v2/icon-good-detail.svg')
          break
        case arrayHistoryIcon.find((item) => item === el):
          imageIcon.value = require('@/assets/images/v2/icon-list.svg')
          break
        // case 'my_page_v2':
        //   imageIcon.value = require('@/assets/images/v2/icon-info-account.svg')
        //   break
        case 'rank_v2':
          imageIcon.value = require('@/assets/images/v2/logo-gongcha.svg')
          break
        default:
          imageIcon.value = require('@/assets/images/v2/icon-home-store.svg')
          break
      }
    }

    const getTitle = (el) => {
      const arrayStore = ['goods_category_v2', 'goodsList_v2']
      switch (el) {
        case arrayStore.find((item) => item === el):
          checkStore.value = true
          title.value = sessionStorage.getItem('storeName')
          break
        case 'good_detail':
          title.value = sessionStorage.getItem('goodsName')
          break
        case 'pay_cancel_v2':
          title.value = '注文失敗'
          break
        // case 'my_page_v2':
        //   title.value = '登録情報'
        //   break
        case 'privacypolicy_v2':
          title.value = 'プライバシーポリシー'
          break
        case 'store_detail_two_v2':
          title.value = '特定商取引法に基づく表記'
          break
        case 'store_detail_v2':
          title.value = '店舗詳細'
          break
        // region Eat-In-Feature
        case 'store_use_type_v2':
          checkStore.value = true
          title.value = sessionStorage.getItem('storeName')
          break
        // endregion Eat-In-Feature
        case 'cart_v2':
          title.value = 'ショッピングカート'
          break
        case 'pay_v2':
          title.value = '注文'
          break
        case 'pay_complete_v2':
          title.value = '注文完了'
          break
        case 'order_history_v2':
          title.value = '注文履歴'
          break
        case 'rank_v2':
          title.value = ''
          break
        case 'waiting_room':
          title.value = 'ウェイティングルーム'
          break
        default:
          title.value = '受取店舗を選ぶ'
          break
      }
    }

    return {
      openHambuger,
      checkStore,
      title,
      confirmCategory,
      imageIcon,
      isErrorPage,
      isHideMenu,
      openModalCofirm,
      confirmModal,
      redirectToHomePage,
      close,
      getIcon,
      getTitle,
      isUserExists
    }
  },
}
</script>